import gql from "graphql-tag"

export default gql`
  mutation deviceAuthApprove($code: String!) {
    deviceAuthApprove(code: $code)
  }
`

